import { moveToFulfilled, moveToPending, moveToRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  GroupClassificationDescriptionLoadAction,
  GroupClassificationDescriptionLoadFulfilledAction,
} from '../../domains/groupClassificationDescriptionLoad/actions.types';

import { GroupClassificationDescription, GroupClassificationDescriptions } from './types';

export type { GroupClassificationDescriptionLoadAction };

const initialState: GroupClassificationDescriptions = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

type NormalizedFulfilledEntities = (
  action: GroupClassificationDescriptionLoadFulfilledAction['payload']
) => Record<string, GroupClassificationDescription>;
const normalizedFulfilledEntities: NormalizedFulfilledEntities = ({ groupId, classification }) => ({
  [groupId]: {
    id: groupId,
    description: (classification && classification.description) ?? undefined,
  },
});

const reducer: Reducer<GroupClassificationDescriptions, GroupClassificationDescriptionLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'GROUP_CLASSIFICATION_DESCRIPTION.LOAD_PENDING':
      return moveToPending(state, [action.payload.groupId]);
    case 'GROUP_CLASSIFICATION_DESCRIPTION.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.groupId], action.payload.error);
    case 'GROUP_CLASSIFICATION_DESCRIPTION.LOAD_FULFILLED':
      return moveToFulfilled(state, normalizedFulfilledEntities(action.payload));
    default:
      return state;
  }
};

export default reducer;
